import React, { useEffect } from "react";
// @ts-ignore: Unreachable code error
import crypto from "crypto-browserify";

import { Flex } from "@chakra-ui/react";
import env from "env";
import LoadingOverlay from "components/LoadingOverlay";
import { Redirect } from "react-router-dom";

const Login = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  const isAutoNavigateWso2Auth = !code 

  const handleLoginWithIDPs = (): void => {
    const base64ToBase64Url = (base64String: string) => {
      return base64String
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_");
    };

    window.localStorage.setItem("token", "");

    const codeVerifier = crypto.randomBytes(32).toString("hex");
    window.localStorage.setItem("code_verifier", codeVerifier);
    const codeChallenge = crypto
      .createHash("sha256")
      .update(codeVerifier)
      .digest("base64");

    const queryParams = {
      response_type: "code",
      client_id: env.app.authCodeAppId,
      redirect_uri: env.app.rootUrl,
      scope: env.api.authScope,
      code_challenge_method: "S256",
    };

    const urlParams = new URLSearchParams(queryParams);
    const baseUrl = `${env.api.baseUrl.tokenBaseUrl}oauth2/authorize`;
    const finalUrl = `${baseUrl}?${urlParams.toString()}&code_challenge=${base64ToBase64Url(
      codeChallenge
    )}`;

    window.location.href = finalUrl;
  };

  useEffect(() => {
    if (isAutoNavigateWso2Auth) {
      // Delay timeout for logout case
      setTimeout(() => {
        handleLoginWithIDPs();
      }, 1000);
    }
  }, [isAutoNavigateWso2Auth]);

  if (isAutoNavigateWso2Auth) {
    return (
      <Flex
        align="center"
        justify="center"
        position="fixed"
        zIndex={10}
        top="-0.5rem"
        left="0"
        w="100%"
        h="100%"
        background="white"
      >
        <LoadingOverlay />
      </Flex>
    );
  }

  if (code ) {
    return (
      <Redirect
        to={`/auth/authorize?code=${code}`}
      />
    );
  }

  return <>Login</>;
};

export default Login;
